/**
 * Copyright (c) 2012 Sonic Electronix.
 * Duplication or modification is prohibited.
 */
jQuery(function ($) {
	$('#ampFinderModal').on('shown.bs.modal	', function (event) {
		// In case the open modal click is from the hanburger menu on iPad Mini, close hanburger.
		$('.left-column .sidebar-closer').click();
	});

	$(document.body).on('ampliFinderFormSubInfo:show', function(e) {
		e.preventDefault();
		$('.ampliFinderFormSubInfo').toggleClass('d-none');
	});

	$('.amplifinderForm form').submit(function(e) {
		e.preventDefault();

		let $manufacturerSelect = $('#AmpFinderFormModel_brand'),
			$productSelect = $('#AmpFinderFormModel_sku'),
			$qtySelect = $('#AmpFinderFormModel_num'),
			productId = $('#AmpFinderFormModel_productId').val();

		if ($manufacturerSelect.val() === '' || $productSelect.val() === '' || $qtySelect.val() === '') {
			if (!$('#ampliFinderFormSubInfoLabel').hasClass('d-none')) {
				$(document.body).trigger('ampliFinderFormSubInfo:show');
			}
		}

		if ($manufacturerSelect.val() === '') {
			$manufacturerSelect.next().next().show().html('Select a manufacturer first.');
			return false;
		} else {
			$manufacturerSelect.next().next().hide();
		}

		if ($productSelect.val() === '') {
			$productSelect.next().next().show().html('Select a subwoofer.');
			return false;
		} else {
			$productSelect.next().next().hide();
		}

		if ($qtySelect.val() === '') {
			$qtySelect.next().next().show().html('Select a number.');
			return false;
		} else {
			$qtySelect.next().next().hide();
		}

		if((typeof productId) == 'string' ) {
			$('#ampFinderModal .close').trigger('click');
			sonicGlobal.overlayActivate();
			let $Spinner = $('.spinner-border').show();
			$.ajax({
				url: '/matching-subwoofers-amps',
				type: 'GET',
				dataType: 'json',
				data: $(this).serialize(),
				success: function(res) {
					if(!res.success) {
						return;
					}

					let $subtextCont = $('.ampliFinderBanner .ampFinderAccordionSubText:first');

					if(res.ampliFinderUrl) {
						let $btnCont = $subtextCont.next();
						$btnCont.find('span.shopAmps').remove();
						$btnCont.append('<span onclick="(arguments[0] || window.event).stopPropagation();" class="shopAmps d-block mt-3"><a href="' +
							res.ampliFinderUrl + '">Shop other compatible amps</a></span>');
					}

					switch(res.amplifierFits) {
						case true:
							$subtextCont.html('Yes this amp works with your sub(s) selected')
								.addClass('text-center');
							break;

						case false:
							$subtextCont.html('This amp does not work with your sub(s) selected')
								.addClass('text-center');
							break;

						default:
							$subtextCont.html('Find compatible amplifiers for the sub with our powerful AmpliFinder&#174; tool.')
								.removeClass('text-center');
					}
				},
				complete: function(xhr) {
					$Spinner.hide();
					sonicGlobal.overlayDeactivate();
				}
			});
		} else {
			window.location = '/matching-subwoofers-amps/'
				+ $qtySelect.val()
				+ '+' + $manufacturerSelect.val().replace(/[^A-Za-z0-9]+/g, '-').toLowerCase()
				+ '+' + $productSelect.find('option:selected').text().replace(/[^A-Za-z0-9_-]+/g, '-').toLowerCase()
				+ '+' + $productSelect.val().toLowerCase();
		}

		return false;
	});

	$('#ampliFinderFormSubInfoChange').click(function () {
		$(document.body).trigger('ampliFinderFormSubInfo:show');
	});

	let ampliFinderSelect2FormSelect = $('#amplifinder-select2-form select');

	if (ampliFinderSelect2FormSelect.length) {
		ampliFinderSelect2FormSelect.each(function() {
			let $this = $(this),
				dropdownParent = $this.closest('.ampliFinderDropdown');

			$this.select2({
				width: '100%',
				dropdownParent: dropdownParent
			});
		});
	}
});